import React from 'react'
import { mdxComponents } from '@/features/blog/components/MdxComponents'
import {
  DocAccordion,
  DocAccordionGroup,
  DocAlert,
  DocCard,
  DocCardGroup,
  DocCodeGroup,
  DocParamField,
  DocTable,
  DocTd,
  DocTh,
  DocThead,
  DocTr,
} from '@/features/docs/components/DocsComponents'
import { DocsCodeBlock } from '@/features/docs/components/DocsCodeBlock'

// Custom pre component that uses DocsCodeBlock for syntax highlighting
function DocsPre(props: any) {
  const codeElement = props.children
  const className = codeElement?.props?.className || ''
  const children = codeElement?.props?.children || ''

  // If there's a language class, use DocsCodeBlock
  if (className?.startsWith('language-')) {
    return <DocsCodeBlock className={className}>{children}</DocsCodeBlock>
  }

  // Otherwise, use default pre
  return <pre {...props} />
}

const docsComponents = {
  ...mdxComponents,
  pre: DocsPre,
  table: DocTable,
  thead: DocThead,
  th: DocTh,
  td: DocTd,
  tr: DocTr,
  // Mintlify component replacements
  Card: DocCard,
  CardGroup: DocCardGroup,
  CodeGroup: DocCodeGroup,
  Warning: (props: any) => <DocAlert variant="warning" {...props} />,
  Note: (props: any) => <DocAlert variant="note" {...props} />,
  Info: (props: any) => <DocAlert variant="info" {...props} />,
  Tip: (props: any) => <DocAlert variant="tip" {...props} />,
  Accordion: DocAccordion,
  AccordionGroup: DocAccordionGroup,
  ParamField: DocParamField,
}

interface DocsContentProps {
  Component: React.ComponentType<{ components?: Record<string, unknown> }>
}

// The MDX body is compiled to a real component at build time (see
// vite.config.ts's @mdx-js/rollup plugin + doc-content.service.ts) — no
// runtime compile step here. Compiling at request time via
// evaluate()/evaluateSync() would call `new Function` under the hood, which
// Cloudflare Workers blocks, breaking SSR for every doc page.
export function DocsContent({ Component }: DocsContentProps) {
  return (
    <article className="prose-custom max-w-none">
      <Component components={docsComponents} />
    </article>
  )
}
